module.exports = __webpack_public_path__ + "media/containers/InvestmentCalculationPDF/Images/wunderAgentLogo-ebf7ee5a675b3a3e476912c16c5f1a1c.png";